import React from 'react';

/**
 * Icon-only expander affordance. Parents that need a control wrap this in a
 * button.
 */
const ExpandDownArrow = ({ onClick }: { onClick?: () => void }) => {
  return (
    <span
      className="button--icon sml border-0"
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick();
              }
            }
          : undefined
      }
    >
      <i className="material-symbols-outlined">arrow_drop_down</i>
    </span>
  );
};

export default ExpandDownArrow;
